import { render, staticRenderFns } from "./logisticsSettings.vue?vue&type=template&id=978c8e92&scoped=true"
import script from "./logisticsSettings.vue?vue&type=script&lang=js"
export * from "./logisticsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978c8e92",
  null
  
)

export default component.exports